"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const use_debounce_1 = require("use-debounce");
exports.OsmosysIframe = (_a) => {
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    const contentRef = react_1.useRef(null);
    const [throttledChildren] = use_debounce_1.useDebounce(children, 50, { maxWait: 200 });
    react_1.useEffect(() => {
        if (contentRef.current && contentRef.current.contentWindow) {
            contentRef.current.contentWindow.document.open();
            contentRef.current.contentWindow.document.write(throttledChildren || '');
            contentRef.current.contentWindow.document.close();
        }
    }, [throttledChildren]);
    return react_1.default.createElement("iframe", Object.assign({}, props, { ref: contentRef }));
};
//# sourceMappingURL=OsmosysIframe.js.map